'use strict';

module.exports = document.createElement('div').style;



//////////////////
// WEBPACK FOOTER
// ./~/domkit/builtinStyle.js
// module id = 1233
// module chunks = 4